
  const sentryInfo = {
  "environment": "production",
  "release": "production@1791983352890"
};
  export default sentryInfo;
